import { fetchReducerGenerator } from 'redpoints-front-common/reducers';

import {
  INCIDENT_DETAILS_CLEAR,
  INCIDENT_DETAILS_FETCH_EVIDENCE_PERMISSIONS,
} from '../../../actions/actionTypes';

const evidencePermissions = fetchReducerGenerator(
  INCIDENT_DETAILS_CLEAR,
  INCIDENT_DETAILS_FETCH_EVIDENCE_PERMISSIONS
);

export default evidencePermissions;
